/**
 * Date utility functions
 */

/**
 * Returns the current year as a string
 * @returns {string} Current year
 */
export const getCurrentYear = (): string => {
  return new Date().getFullYear().toString();
};